"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const valueIsRecord_1 = __importDefault(require("../../../typeAssertions/valueIsRecord"));
const valueIsControlCalendarMarkedDate_1 = __importDefault(require("../../../typeAssertions/valueIsControlCalendarMarkedDate"));
const valueIsArray_1 = __importDefault(require("../../../typeAssertions/valueIsArray"));
const getControlsColorSpecificationByString_1 = __importDefault(require("../../../shared/getControlsColorSpecificationByString"));
const reduceValidMarkedDate = (markeds, getColor) => {
    let data;
    if ((0, valueIsRecord_1.default)(markeds)) {
        data = Object.values(markeds);
    }
    if ((0, valueIsArray_1.default)(markeds)) {
        data = [...markeds];
    }
    return (data || []).reduce((newMarkeds, marked) => {
        if ((0, valueIsControlCalendarMarkedDate_1.default)(marked)) {
            const color = marked.color
                ? getColor((0, getControlsColorSpecificationByString_1.default)(marked.color))
                : undefined;
            const textColor = marked.textColor
                ? getColor((0, getControlsColorSpecificationByString_1.default)(marked.textColor))
                : undefined;
            const selectedColor = marked.selectedColor
                ? getColor((0, getControlsColorSpecificationByString_1.default)(marked.selectedColor))
                : undefined;
            const dotColor = marked.dotColor
                ? getColor((0, getControlsColorSpecificationByString_1.default)(marked.dotColor))
                : undefined;
            let dateMarked = marked.date;
            if (/^[0-9]*$/.test(dateMarked)) {
                dateMarked = (0, moment_1.default)(dateMarked, 'x').format('YYYY-MM-DD');
            }
            if (/^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/.test(dateMarked)) {
                return Object.assign(Object.assign({}, newMarkeds), { [dateMarked]: {
                        marked: marked.marked,
                        selected: marked.selected,
                        disabled: marked.disabled,
                        disableTouchEvent: marked.disableTouchEvent,
                        color,
                        textColor,
                        selectedColor,
                        dotColor,
                    } });
            }
        }
        return newMarkeds;
    }, {});
};
exports.default = reduceValidMarkedDate;
